import React from "react";
import {
  contactData,
  experiencesData,
  formationsData,
  inspirationsData,
} from "./data-informations.js"; // adapte le chemin si besoin

import "./style.scss";

const Informations = () => {
  return (
    <section className="informations">
      {/* CONTACT */}
      <section className="contact">
        <h3>CONTACT</h3>
        <a
          href="/LeanneLopez-CV.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="cv-link"
        >
          <h4>Curriculum Vitae</h4>
        </a>
        <p>
          {contactData.location} <br />
          {contactData.email}
        </p>
        <br />
        <div className="reseaux-sociaux">
          {contactData.social?.map((item, index) => (
            <p key={index}>
              {item.handle} [{item.name}]
            </p>
          ))}
        </div>
      </section>

      {/* EXPÉRIENCES */}
      <section className="experiences">
        <h3>EXPÉRIENCES</h3>
        {experiencesData.map((item, index) => (
          <div key={index} className="experience-item">
            <h4>{item.title}</h4>
            <p>
              {item.company} <br />
              {item.years}
            </p>
          </div>
        ))}
      </section>

      {/* FORMATIONS */}
      <section className="formations">
        <h3>FORMATIONS</h3>
        {formationsData.map((item, index) => (
          <div key={index} className="formation-item">
            <h4>{item.title}</h4>
            <p>
              {item.school} <br />
              {item.years}
              {item.schoolSecond && (
                <>
                  <br />
                  {item.schoolSecond}
                </>
              )}
              {item.yearsSecond && (
                <>
                  <br />
                  {item.yearsSecond}
                </>
              )}
            </p>
          </div>
        ))}
      </section>

      {/* INSPIRATIONS */}
      <section className="inspirations">
        <h3>INSPIRATIONS</h3>
        {inspirationsData.map((item, index) => (
          <div key={index} className="inspiration-item">
            <h4>{item.title}</h4>
            <p>
              {item.location} <br />
              {item.years}
              {item.locationSecond && (
                <>
                  <br />
                  {item.locationSecond}
                </>
              )}
              {item.yearsSecond && (
                <>
                  <br />
                  {item.yearsSecond}
                </>
              )}
            </p>
          </div>
        ))}
      </section>
    </section>
  );
};

export default Informations;
